module.exports = __webpack_public_path__ + "media/categories/1024-82136e88.svg";